export const posProductKeys = {
	all: ['pos-products'] as const,
	lists: () => [...posProductKeys.all, 'list'] as const,
	list: (filters?: any) => [...posProductKeys.lists(), filters ?? {}] as const,
	details: () => [...posProductKeys.all, 'detail'] as const,
	detail: (id: string) => [...posProductKeys.details(), id] as const,
};
